import { ComponentType, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import useAuth from 'hooks/useAuth';
import { useRedirect } from 'contexts/RedirectContext';

import Loader from './Loader';

export function withCustomerAuth<P extends object>(Component: ComponentType<P>) {
  return function AuthenticatedComponent(props: P) {
    const navigate = useNavigate();
    const location = useLocation();
    const { isLoggedIn, isInitialized } = useAuth();
    const { setRedirectAfterLogin } = useRedirect();

    useEffect(() => {
      if (isInitialized && !isLoggedIn) {
        setRedirectAfterLogin(location.pathname + location.search);
        navigate('/customer/login', { replace: true });
      }
    }, [isInitialized, isLoggedIn, location.pathname, location.search, setRedirectAfterLogin, navigate]);

    if (!isInitialized || !isLoggedIn) {
      return <Loader />;
    }

    return <Component {...props} />;
  };
}
